/** Kannada: the model on this phone: Settings › On-device model, and the chat's one offer and lines about it. */
export const model = {
    "model.title": "ನಿಮ್ಮ ಏಜೆಂಟ್‌ನ ಮಾಡೆಲ್",
    "model.check": "ಮತ್ತೆ ಪರಿಶೀಲಿಸಿ",
    "model.checking": "ಈ ಫೋನನ್ನು ಪರಿಶೀಲಿಸಲಾಗುತ್ತಿದೆ…",
    "model.none": "ಈ ಫೋನ್‌ನಲ್ಲಿ ಮಾಡೆಲ್ ಇಲ್ಲ.",
    "model.ready": "ಸಿದ್ಧ",
    "model.not_ready": "ಸಿದ್ಧವಾಗಿಲ್ಲ",
    "model.free_mb": "{mb} ಎಂಬಿ ಖಾಲಿ",
    "model.auto": "ತಾನಾಗಿಯೇ",
    "model.auto_about": "GigSync ನ ಸ್ವಂತ ಮಾಡೆಲ್, ಭಾರತದಲ್ಲಿರುವ GigSync ಕಂಪ್ಯೂಟರ್‌ನಲ್ಲಿ, ನಿಮ್ಮ ಮಾತು ಅರ್ಥಮಾಡಿಕೊಳ್ಳಲು ನೀವು ಬರೆದದ್ದನ್ನು ಓದುತ್ತದೆ; ಅದನ್ನು ಇಟ್ಟುಕೊಳ್ಳುವುದಿಲ್ಲ. ಅದು ಸಿಗದಿದ್ದರೆ, ಫೋನಿನ ಮಾಡೆಲ್ ಸಿದ್ಧವಿದ್ದರೆ ಅದು; ಇಲ್ಲದಿದ್ದರೆ ಲೈಟ್ ಮೋಡ್.",
    "model.device": "ಫೋನ್‌ನಲ್ಲಿ",
    "model.device_about": "ಯಾವಾಗಲೂ ಫೋನಿನ ಸ್ವಂತ ಮಾಡೆಲ್. ಉತ್ತರಿಸಲಾಗದಿದ್ದರೆ ಮಾತ್ರ ಲೈಟ್ ಮೋಡ್.",
    "model.lite": "ಲೈಟ್ ಮೋಡ್",
    "model.lite_about": "ಯಾವುದೇ ಮಾಡೆಲ್ ಇಲ್ಲ. ನಿಯಮಗಳು ಮತ್ತು ಸಿದ್ಧ ಪಠ್ಯಗಳು ಎಲ್ಲವನ್ನೂ ಮಾಡುತ್ತವೆ: ಒಪ್ಪಂದ, ದಾಖಲೆ, ಪಾವತಿ.",
    "model.ollama": "Ollama (ಡೆವ್)",
    "model.ollama_about": "ಡೆವಲಪ್‌ಮೆಂಟ್ ಬಿಲ್ಡ್‌ಗಳಲ್ಲಿ ಮಾತ್ರ: ಈ ಕಂಪ್ಯೂಟರ್‌ನಲ್ಲಿ `ollama serve` ಮೂಲಕ ಮಾಡೆಲ್.",
    "model.ollama_model": "Ollama ಮಾಡೆಲ್",
    "model.ollama_choose": "Ollama ನಲ್ಲಿರುವ ಮಾಡೆಲ್ ಆಯ್ಕೆಮಾಡಿ",
    "model.ollama_name": "Ollama ಮಾಡೆಲ್‌ನ ಹೆಸರು",
    "model.ollama_off": "Ollama ಚಾಲನೆಯಲ್ಲಿಲ್ಲ: `ollama serve` ಆರಂಭಿಸಿ, ಅಥವಾ ಹೆಸರು ಬರೆಯಿರಿ",
    "model.ollama_looking": "Ollama ಹುಡುಕಲಾಗುತ್ತಿದೆ…",
    "model.use": "ಈ ಮಾಡೆಲ್ ಬಳಸಿ",
    "model.now": "ಈಗ ಉತ್ತರಿಸುತ್ತಿರುವುದು: {model}",
    "model.still_works": "ಲೈಟ್ ಮೋಡ್‌ನಲ್ಲೂ ಎಲ್ಲವೂ ಕೆಲಸ ಮಾಡುತ್ತದೆ; ಮಾಡೆಲ್ ಪದಗಳಿಗೆ ಮಾತ್ರ ಸಹಾಯ ಮಾಡುತ್ತದೆ.",
    "model.lite_label": "ಲೈಟ್ ಮೋಡ್ (ಮಾಡೆಲ್ ಇಲ್ಲ)",
    "model.ollama_label": "Ollama: {name} (ಡೆವ್)",
    "model.not_ready_lite": "{device} · ಸಿದ್ಧವಿಲ್ಲ, ಆದ್ದರಿಂದ ಲೈಟ್ ಮೋಡ್",
    "model.on_device_label": "ಫೋನ್‌ನಲ್ಲಿ: {engine}",
    "model.auto_label": "ತಾನಾಗಿಯೇ · {model}",
    "model.server_label": "GigSync ಮಾಡೆಲ್",
    "model.offer": "ನಿಮ್ಮ ಏಜೆಂಟ್ ನಿಮ್ಮನ್ನು ಇನ್ನೂ ಚೆನ್ನಾಗಿ ಅರ್ಥಮಾಡಿಕೊಳ್ಳಲು: ಈ ಫೋನ್‌ಗೆ ಸುಮಾರು {mb} ಎಂಬಿ ಡೌನ್‌ಲೋಡ್ ಮಾಡಿ.",
    "model.offer_download": "ಡೌನ್‌ಲೋಡ್ ಮಾಡಿ",
    "model.offer_later": "ನಂತರ",
    "model.mobile_data": "ನೀವು ಮೊಬೈಲ್ ಡೇಟಾದಲ್ಲಿದ್ದೀರಿ: ಇದಕ್ಕೆ ಸುಮಾರು {mb} ಎಂಬಿ ಡೇಟಾ ಬೇಕು.",
    "model.wifi_best": "ವೈ-ಫೈನಲ್ಲಿ ಮಾಡುವುದು ಉತ್ತಮ.",
    "model.private": "ಇದು ಈ ಫೋನ್‌ನಲ್ಲಿ ಮಾತ್ರ ನಡೆಯುತ್ತದೆ: ನೀವು ಬರೆಯುವುದು ಫೋನಿನಿಂದ ಹೊರಗೆ ಹೋಗುವುದಿಲ್ಲ.",
    "model.downloading": "ಮಾಡೆಲ್ ಈ ಫೋನ್‌ಗೆ ಡೌನ್‌ಲೋಡ್ ಆಗುತ್ತಿದೆ: {percent}% ({mb} ರಲ್ಲಿ {done} ಎಂಬಿ)",
    "model.paused": "ಮಾಡೆಲ್ ಡೌನ್‌ಲೋಡ್ ಅರ್ಧದಲ್ಲಿ ನಿಂತಿದೆ. ನಿಂತಲ್ಲಿಂದಲೇ ಮುಂದುವರಿಯುತ್ತದೆ.",
    "model.resume": "ಡೌನ್‌ಲೋಡ್ ಮುಂದುವರಿಸಿ",
    "model.ready_line": "ನಿಮ್ಮ ಏಜೆಂಟ್ ಈಗ ಈ ಫೋನ್‌ನಲ್ಲೇ ನಡೆಯುತ್ತದೆ, ಇಂಟರ್ನೆಟ್ ಇಲ್ಲದಿದ್ದರೂ",
    "model.state_ready": "ಸಿದ್ಧ",
    "model.state_downloadable": "ಡೌನ್‌ಲೋಡ್ ಆಗಿಲ್ಲ",
    "model.state_downloading": "ಡೌನ್‌ಲೋಡ್ ಆಗುತ್ತಿದೆ {percent}%",
    "model.line": "{name} · ಸುಮಾರು {mb} ಎಂಬಿ · {state}",
    "model.download": "ಡೌನ್‌ಲೋಡ್ ಮಾಡಿ (ಸುಮಾರು {mb} ಎಂಬಿ)",
    "model.remove": "ಈ ಫೋನಿನಿಂದ ತೆಗೆದುಹಾಕಿ",
    "model.why.no_webgpu": "ಈ ಬ್ರೌಸರ್ ಈ ಫೋನ್‌ನಲ್ಲಿ ಮಾಡೆಲ್ ನಡೆಸಲಾರದು (WebGPU ಇಲ್ಲ). ಲೈಟ್ ಮೋಡ್ ಎಲ್ಲ ಕೆಲಸ ಮಾಡುತ್ತದೆ.",
    "model.why.gpu_limits": "ಈ ಫೋನಿನ ಗ್ರಾಫಿಕ್ಸ್ ಚಿಪ್ ಮಾಡೆಲ್‌ಗೆ ಸಾಲದು. ಲೈಟ್ ಮೋಡ್ ಎಲ್ಲ ಕೆಲಸ ಮಾಡುತ್ತದೆ.",
    "model.why.low_memory": "ಈ ಫೋನ್‌ನಲ್ಲಿ ಮಾಡೆಲ್‌ಗೆ ಮೆಮೊರಿ ಕಡಿಮೆ. ಲೈಟ್ ಮೋಡ್ ಎಲ್ಲ ಕೆಲಸ ಮಾಡುತ್ತದೆ.",
    "model.why.unknown_memory": "ಈ ಫೋನ್‌ನಲ್ಲಿ ಎಷ್ಟು ಮೆಮೊರಿ ಇದೆ ಅಂತ ಈ ಬ್ರೌಸರ್ ಹೇಳುವುದಿಲ್ಲ, ಹಾಗಾಗಿ ಮಾಡೆಲ್ ಕೊಡುವುದಿಲ್ಲ. ಅರ್ಥಮಾಡಿಕೊಳ್ಳುವ ಪ್ಯಾಕ್ ಆ ಕೆಲಸ ಮಾಡುತ್ತದೆ.",
    "model.why.low_storage": 'ಮಾಡೆಲ್‌ಗೆ ಜಾಗ ಸಾಲದು. ಸ್ವಲ್ಪ ಜಾಗ ಖಾಲಿ ಮಾಡಿ, ನಂತರ "ಮತ್ತೆ ಪರಿಶೀಲಿಸಿ" ಒತ್ತಿ.',
    "model.why.browser": "ಈ ಬ್ರೌಸರ್ ಮಾಡೆಲ್ ಇಟ್ಟುಕೊಳ್ಳಲಾರದು. ಹೊಸ ಕ್ರೋಮ್ ಅಥವಾ ಸಫಾರಿ ಬಳಸಿ.",
};
//# sourceMappingURL=model.js.map